<template>
	<div class="report">
		<Heading title="Relatório da Carteira" class="report-title" />
		<Heading :level="2" :hasBorderBottom="true" title="Últimos envios" class="report-subtitle" />
		<TableList
			v-if="!isLoading"
			class="report__table"
			:headers="headers"
			:data="data"
			ariaLabel="Sent Reports list"
		/>

		<div v-if="!isLoading" class="report__buttons">
			<ButtonTertiary
				label="Enviar para os Investidores"
				class="report__button-primary"
				size="xl"
				@click="setUserRoleId(userRolesEnum().INVESTOR)"
			/>
			<ButtonSecondary
				label="Enviar para o Originador"
				class="report__button-secondary"
				size="xl"
				@click="setUserRoleId(userRolesEnum().ORIGINATOR)"
			/>
		</div>

		<Modal
			v-if="modal.isOpen"
			:title="modal.title"
			:description="modal.description"
			:primaryLabel="modal.primaryLabel"
			:secondaryLabel="modal.secondaryLabel"
			@secondaryClick="toggleModal"
			@primaryClick="handleSendReport"
		></Modal>

		<div class="report__loading">
			<SpinnerIcon v-if="isLoading" />
		</div>
	</div>
</template>
<script>
import Heading from '@/components/shared/Heading/Heading.vue';
import TableList from '@/components/shared/Table/TableList.vue';
import ButtonTertiary from '@/components/shared/Button/ButtonTertiary/ButtonTertiary.vue';
import ButtonSecondary from '@/components/shared/Button/ButtonSecondary/ButtonSecondary.vue';
import SpinnerIcon from '@/components/shared/Icons/SpinnerIcon.vue';
import Modal from '@/components/shared/Modal/Modal.vue';
import UserRoleEnum from '@/enums/UserRoleEnum';
import api from '@/utils/api';

export default {
	name: 'OfferReport',
	components: {
		ButtonSecondary,
		ButtonTertiary,
		SpinnerIcon,
		Heading,
		TableList,
		Modal,
	},
	data: () => ({
		http: api.getInstance().http,
		isLoading: true,
		headers: [
			{
				label: 'Data',
			},
			{
				label: 'Relatório',
			},
			{
				label: 'Destinatário',
			},
		],
		data: [],
		userRoleId: null,
		isModalOpen: false,
	}),
	async created() {
		await this.getList();
	},
	methods: {
		async getList() {
			try {
				const offerId = this.$route.params.id;
				const { data } = await this.http(`/wallet-report/${offerId}`);
				this.data = this.transformDateFormatToBrazilian(data);
			} catch (error) {
				this.$toastr.e(error.response.data.message);
			} finally {
				this.isLoading = false;
			}
		},
		async sendReport(userRoleId) {
			try {
				this.isLoading = true;
				const offerId = this.$route.params.id;
				await this.http({
					method: 'POST',
					url: `/wallet-report/${offerId}`,
					data: { userRoleId },
				});
				const { data } = await this.http(`/wallet-report/${offerId}`);
				this.data = this.transformDateFormatToBrazilian(data);
				this.$toastr.s('Relatório enviado com sucesso');
			} catch (error) {
				this.$toastr.e(error.response.data.message);
			} finally {
				this.isLoading = false;
			}
		},
		userRolesEnum() {
			return UserRoleEnum;
		},
		transformDateFormatToBrazilian(data) {
			return data.map((report) => {
				const date = this.$moment(report.createdAt).format('DD/MM/YYYY');
				report.createdAt = date;
				return report;
			});
		},
		setUserRoleId(userRoleId) {
			this.userRoleId = userRoleId;
			this.toggleModal();
		},
		toggleModal() {
			this.isModalOpen = !this.isModalOpen;
		},
		handleSendReport() {
			this.toggleModal();
			this.sendReport(this.userRoleId);
		},
	},
	computed: {
		modalTitle() {
			const title = {
				[UserRoleEnum.INVESTOR]:
					'Tem certeza que deseja enviar o relatório para os Investidores desta Oferta?',
				[UserRoleEnum.ORIGINATOR]:
					'Tem certeza que deseja enviar o relatório para os Originadores desta Oferta?',
			};

			return title[this.userRoleId];
		},
		modalDescription() {
			const description = {
				[UserRoleEnum.INVESTOR]:
					'Ao confirmar, um e-mail será enviado para todos os investidores da Oferta.',
				[UserRoleEnum.ORIGINATOR]:
					'Ao confirmar, um e-mail será enviado para todos os usuários vinculados ao Originador da Oferta.',
			};

			return description[this.userRoleId];
		},
		modal() {
			return {
				isOpen: this.isModalOpen,
				title: this.modalTitle,
				description: this.modalDescription,
				primaryLabel: 'Sim',
				secondaryLabel: 'Não',
			};
		},
	},
};
</script>
<style lang="scss" scoped>
@import './OfferReport.scss';
</style>
